import * as React from 'react';
import * as styles from "./App.css";
import { NavigationBar } from './navigationBar/NavigationBar';
import { AppStore } from './stores';
import { inject, observer, Provider } from 'mobx-react';
import { TabBar } from './tabBar/TabBar';
import { ContentArea } from './contentArea/ContentArea';
import { Menu } from './menu/Menu';
import { Settings } from './settings/Settings';
import InstanceService from '../../services/InstanceService';
import { IInstance } from '../../interfaces/IInstance';
import PushService from '../../services/PushService';
import NativeService from '../../services/NativeService';
import MessageService from '../../services/MessageService';
import { IMessageResult } from '../../interfaces/IMessageResult';
import { MessagesStore } from '../messages/stores';
import { OldViewPanel } from '../messages/panels/OldViewPanel';
import UserService from '../../services/UserService';
import { Environment } from '../../services/Environment';
import { IUserRole } from '../../interfaces/IUserRole';
import { TabBarPanel } from './tabBarPanel/TabBarPanel';
import { ViewPanel } from '../messages/panels/ViewPanel';
import { EditPanel } from '../messages/panels/EditPanel';
import { IHttpStatus } from '../../interfaces/IHttpStatus';
import { LoggingService } from '../../services/LoggingService';

export interface IAppProps {
  store?: AppStore;
  instance?: IInstance;
  selectedPageIndex?: number;
  previewSplashScreen?: boolean;
  editMode?: boolean;
  switchApp?: () => void;
  logOut?: () => void;
  selectPage?: (index: number) => void;
}

@inject('store')
@observer
export class App extends React.Component<IAppProps> {

  private messagesStore: MessagesStore = new MessagesStore();

  constructor(props: IAppProps) {
    super(props);
    LoggingService.init(this.props.store.environment);
    this.detectPlatform();
    NativeService.getVersion();
    const viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute('content', 'viewport-fit=cover, width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    // Disable bounce in iOS
    if (window.platform === "ios") {
      document.addEventListener("touchmove", function (event) {
        event.preventDefault();
      });
    }
  }

  public componentDidMount(): void {
    console.log("App (SDK-UI) didmount");
    this.getInstanceSettings();
  }

  public componentWillReceiveProps(props: IAppProps): void {
    if (props.selectedPageIndex !== this.props.selectedPageIndex) {
      this.props.store.selectedPageIndex = props.selectedPageIndex;
      this.props.selectPage(props.selectedPageIndex);
      if (this.props.store.instance?.settings?.menu) {
        this.props.store.pages = new Array(this.props.store.instance.settings.menu.length);
      }
    }
  }

  private detectPlatform(): void {
    if (navigator.userAgent.toLowerCase().indexOf("android") > -1 && window.android != undefined) {
      window.platform = "android";
    } else {
      window.platform = "ios";
    }
    console.log("Platform: " + window.platform);
  }

  private getInstanceSettings(): void {
   let targeting = window.location?.href?.indexOf("intraactive-admin") === -1 && window.location?.href?.indexOf("AppAdmin") === -1;
    InstanceService.getInstanceIdByName(this.props.store.environment, this.props.store.token, this.props.store.tenant, "IntraActive-AppAdmin", this.props.store.instance?.instanceName, targeting).then((instance: IInstance) => {
      if (instance?.settings) {
        this.props.store.instance = instance;
        this.props.store.selectedPageIndex = 0;
        this.props.store.pages = new Array(this.props.store.instance.settings.menu.length);
        this.props.store.selectedPageIndex = 0;
        this.forceUpdate();
        this.initMessagesStore();
        this.getUser();
      }
    });
  }

  private getUser(): void {
    UserService.getUserRole(
      Environment.getEnvironmentForMainAPI(this.props.store.environment),
      this.props.store.tenant,
      this.props.store.instance?.id,
      this.props.store.token,
      'IntraActive-AppAdmin',
    ).then((userRole: IUserRole) => {
      this.props.store.user = userRole.user;
      this.messagesStore.setUserRole(userRole);
    });
  }

  private initMessagesStore(): void {
    this.messagesStore.token = this.props.store.token;
    this.messagesStore.tenant = this.props.store.tenant;
    this.messagesStore.environment = this.props.store.environment;
    this.messagesStore.highlightColor = this.props.store.instance.settings.design.contentAreaHighlightColor;
    this.messagesStore.isMobile = true;
  }

  public render(): JSX.Element {
    let openInNewViewer = this.messagesStore.instance && this.messagesStore.messageToOpen?.iaConfiguration?.composerComponents;
    const top = window.platform === "android" ? 50 : this.props.store.isIPhoneXType ? 90 : 70;
    return this.props.store.instance && this.props.store.instance.settings && this.props.store.instance.settings.design ? (
      <div
        id="IA_App"
        className={styles.IA_app}
        style={{
          width: this.props.store.preview ? 350 : "100%",
          height: this.props.store.preview ? 700 : "100vh"
        }}
      >
        <NavigationBar />
        {this.props.store.pages &&
          <ContentArea
            selectedPageIndex={this.props.store.selectedPageIndex}
            hasChanges={undefined}
            editMode={this.props.editMode}
          />
        }
        {/* <ContentMapPanel /> */}
        {/* <NavigatorPanel /> */}
        {this.props.store.instance.settings.design.menuStyle === "TabBar" &&
          <TabBarPanel
            selectPage={this.props.selectPage ? (index) => this.props.selectPage(index) : undefined}
          />
        }
        {this.props.store.instance.settings.design.menuStyle === "TabBar" && (this.props.store.instance.settings.menu.length > 1 || this.props.store.editMode) &&
          <TabBar
            selectPage={this.props.selectPage ? (index) => {
              this.props.selectPage(index)
            } : undefined}
          />
        }
        {this.props.store.instance.settings.design.menuStyle === "Burger" && (this.props.store.instance.settings.menu.length > 1 || this.props.store.editMode) &&
          <Menu />
        }
        <Settings
          switchApp={() => this.props.switchApp()}
          logOut={() => this.props.logOut()}
          show={this.props.store.showSettings}
        />
        <Provider messagesStore={this.messagesStore}>
          <>
            <OldViewPanel
              id={this.messagesStore.messageToOpen && !openInNewViewer ? this.messagesStore.messageToOpen.id : undefined}
              dataAutomationIdPrefix="messages-view-panel"
              top={top}
            />
            <ViewPanel
              id={this.messagesStore.messageToOpen && openInNewViewer ? this.messagesStore.messageToOpen.id : undefined}
              dataAutomationIdPrefix="messages-view-panel"
              top={top}
            />
            <EditPanel
              dataAutomationIdPrefix="messages-edit-panel"
              onClose={() => {
                this.messagesStore.messageToEdit = undefined;
              }}
              reloadMessages={() => {
                this.messagesStore.messageToEdit = undefined;
              }}
            />
          </>
        </Provider>
      </div>
    ) : (
      <div></div>
    );
  }

  //////////////////////////////////////////////// Navitive interface ////////////////////////////////////////////////

  public showMessage(message: string): void {
    alert(message);
  }

  public reloadApp(): void {
    this.props.store.reloadPage();
  }

  public closePanel(): void {
    if (this.messagesStore.messageToOpen) {
      // closing push message
      this.messagesStore.closeMessage();
      return;
    }
    if (this.props.store?.openedPanelMessageStore && this.props.store.openedPanelMessageStore.messageToOpen) {
      // closing opened message panel
      this.props.store.openedPanelMessageStore.closeMessage();
      return;
    }
  }

  public registerDevice(pushToken: string, platform: "android" | "ios"): void {
    PushService.registerDevice(this.props.store.environment, this.props.store.tenant, pushToken, platform);
  }

  public isCustomApp(): void {
    this.props.store.isCustomApp = true;
  }

  public getVersion(version: string): void {
    this.props.store.nativeVersion = version;
  }

  // This is being called when opening a push notification
  public showPushContent(type: string, source: string, id: string): void {
    this.closePanel();
    let instance = "Default";
    if (source) {
      instance = source;
    }
    if (type === "message") {
      MessageService.getInstanceSettings(instance, this.messagesStore.environment, this.messagesStore.tenant, this.messagesStore.token).then((result: { httpStatus: IHttpStatus, instance: IInstance }) => {
        if (result.httpStatus.statusCode === 200) {
          if (!result.instance.instanceName) {
            result.instance.instanceName = "Default";
          }
          this.messagesStore.instance = result.instance;
          MessageService.getMessage(this.props.store.environment, this.props.store.token, this.props.store.tenant, result.instance.instanceName, parseInt(id)).then((messageResult: IMessageResult) => {
            this.messagesStore.likesEnabled = true;
            this.messagesStore.commentsEnabled = true;
            this.messagesStore.width = 600;
            this.messagesStore.component = "Messages";
            this.messagesStore.isMobileApp = true;
            messageResult.messages[0].likes = undefined;
            messageResult.messages[0].commentCount = undefined;
            this.messagesStore.openMessage(messageResult.messages[0]);
            this.messagesStore.isTargetingAvailable = true; // TODO
            this.messagesStore.creatingNewMessage = false;
            this.messagesStore.categoryNodes = undefined;
            this.messagesStore.messageToOpen = messageResult.messages[0];
            NativeService.willShowPushContent();
            this.render();
          });
        }
      })
    }
  }

}